const accordions = document.querySelectorAll('.accordion');

if (accordions.length > 0) {
  accordions.forEach(accordion => {
    const items = accordion.querySelectorAll('.accordion__item');

    if (items.length > 0) {
      items.forEach(item => {
        const header = item.querySelector('.accordion__header');

        if (header) {
          header.addEventListener('click', () => {
            const isActive = item.classList.contains('is-active');

            items.forEach(i => i.classList.remove('is-active'));

            if (!isActive) {
              item.classList.add('is-active');
            }
          });
        }
      });
    }
  });
}
